import lodash from 'lodash';

export const hasSelectedItem = 
    (staffDocumentExpectations, toDelete) => 
        toDelete.length > 0 && toDelete.length < staffDocumentExpectations.length;
export const isAllSelected = 
    (staffDocumentExpectations, toDelete) => 
        toDelete.length > 0 && staffDocumentExpectations.length === toDelete.length;

export function isChecked(expectationId, toDelete){
    return toDelete.some( id => id === expectationId);
}

export function toggleSingleCheckbox(expectationId, toDelete){
    return toDelete.includes(expectationId) ? 
        toDelete.filter((item) => item !==expectationId) :
        lodash.uniq([...toDelete, expectationId]);
}

export function isAllRolesSelectedForCategory(expectations, toDelete){
    if(lodash.isEmpty(toDelete))( false );

    const staffExpectationsIds = getExpectationIds(expectations);
    return staffExpectationsIds.every(expectation => toDelete.includes(expectation));
}

export function isCategoryPartiallySelected(expectations, toDelete){
    const checkedItem = lodash.filter(expectations, expectation => 
        toDelete.includes(expectation.id)
    );
    return hasSelectedItem(expectations, checkedItem);
}
export function toggleCategoryCheckbox(expectations, toDelete){
    const staffExpectationsIds = getExpectationIds(expectations);
    
    return isAllRolesSelectedForCategory(expectations, toDelete) ? 
        lodash.differenceBy(toDelete, staffExpectationsIds) :
        lodash.uniq([...toDelete, ...staffExpectationsIds]);
}

const getExpectationIds = (expectations) => expectations.map(expectation => expectation.id);
